import React from 'react'
import styled from 'styled-components'
import { useGetApiPrice } from 'state/hooks'
import { getBalanceNumber } from 'utils/formatBalance'
import { getPoolApy } from 'utils/apy'
import { Pool } from 'state/types'

const Container = styled.div`
  display: flex;
  align-items: center;
  color: #ffffff97;
  font-size: 18px;
`

const AprWrapper = styled.div`
  min-width: 60px;
  text-align: left;
`

interface PoolAprProps {
  pool: Pool
}

const PoolApr: React.FC<PoolAprProps> = ({ pool }) => {
  const rewardTokenPrice = useGetApiPrice(pool.earningToken.symbol)
  const stakingTokenPrice = useGetApiPrice(pool.stakingToken.symbol)
  const apy = getPoolApy(
    stakingTokenPrice,
    rewardTokenPrice,
    getBalanceNumber(pool.totalStaked, pool.stakingToken.decimals),
    parseFloat(pool.tokenPerSecond || '0'),
  )
  const fixedApy = Number(apy).toFixed(2)

  return (
    <Container>
      <AprWrapper>{pool.isFinished || !apy || Number.isNaN(Number(apy)) ? '-' : `${fixedApy}%`}</AprWrapper>
    </Container>
  )
}

export default PoolApr
